import React from 'react';
import { Waves, Coffee, Footprints, ShoppingBag, Camera, Sun } from 'lucide-react';
import { useReveal, JoinBlock, InstagramSection, PageHeader } from '../components/shared';
import { IMAGES } from '../mock';

const PICKS = [
  [Waves, 'Surf', 'Bells Beach & Torquay Surf Beach', 'Watch the world-famous break from the Bells clifftops at first light, or learn on the gentle beginner waves at Torquay front beach. Board hire and lessons line the Esplanade.'],
  [Coffee, 'Eat & Drink', 'Coffee on the Esplanade', 'Torquay does a very good flat white. Follow the locals along Gilbert Street and the Esplanade for bakeries, brunch and fish and chips eaten on the grass above the beach.'],
  [Footprints, 'Walk', 'Surf Coast Walk', 'A clifftop path that runs from Point Impossible to Fairhaven. Do the Torquay-to-Jan Juc leg for wildflowers, sea eagles and long views back over the bay.'],
  [Sun, 'See', 'Point Danger & the Great Ocean Road arch', 'The official start of the Great Ocean Road. Point Danger gives you the whole coastline in one look — and the memorial arch at Eastern View is worth the drive.'],
  [ShoppingBag, 'Shop', 'Surf Coast Plaza & the makers', 'Surf-brand outlets, Australian labels and small makers between the highway and the sea. Saturday mornings bring the Torquay farmers market to the foreshore.'],
  [Camera, 'Photograph', 'Golden hour on the foreshore', 'Rocky pools at Cosy Corner, Norfolk pines along the Esplanade and the pier at sunset — bring the camera, and a bunch of dahlias if you like.'],
];

export default function Explore({ go }) {
  useReveal([]);
  return (
    <div className="page active" data-testid="explore-page">
      <PageHeader eyebrow="Surf Coast Victoria" title="Discover Torquay" sub="Where the Great Ocean Road begins" bg="/brand/pages/torquay-front-beach.webp" credit={{ text: 'Photo: 1geel0ng1 · CC BY 4.0', href: 'https://commons.wikimedia.org/w/index.php?curid=196406528' }} cta="Follow Our Adventures" ctaPink onCta={() => window.open('https://instagram.com/southbeachblooms', '_blank')} />

      <div className="fh-intro">
        <span className="eyebrow rev">Our little corner of the coast</span>
        <h2 className="serif-h rev">Come for the flowers,<em>stay for the coast.</em></h2>
        <p className="body-text rev">Torquay is the town we surf before work, swim after it, and grow dahlias in between. If you&rsquo;re passing through on the way to the Great Ocean Road — or making a weekend of it — these are the places we&rsquo;d send our friends.</p>
      </div>

      <div className="explore-hero-grid">
        <div className="explore-hero bg-photo rev" style={{ backgroundImage: 'url(/brand/pages/explore-bells.webp)' }}><span className="explore-hero-cap">Bells Beach</span></div>
        <div className="explore-hero bg-photo rev" style={{ backgroundImage: 'url(/brand/pages/explore-walk.webp)' }}><span className="explore-hero-cap">Surf Coast Walk</span></div>
        <div className="explore-hero bg-photo rev" style={{ backgroundImage: 'url(/brand/pages/explore-cafe.webp)' }}><span className="explore-hero-cap">Coffee on the Esplanade</span></div>
      </div>

      <div className="explore-list">
        {PICKS.map(([Ic, cat, t, d], i) => (
          <div className="explore-item rev" key={i} data-testid={`explore-item-${i}`}>
            <span className="offer-icon"><Ic size={26} strokeWidth={1.3} /></span>
            <div>
              <span className="explore-cat">{cat}</span>
              <div className="explore-t">{t}</div>
              <p className="explore-d">{d}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="split home-split">
        <div className="split-copy" style={{ order: 1 }}>
          <span className="eyebrow rev">And then, the farm</span>
          <h2 className="home-split-h rev">Fresh flowers,<em>on your way through</em></h2>
          <p className="body-text rev">When the paddock allows, farm-gate bunches of dahlias, cosmos and ranunculus are out in season, and pick-your-own sessions run on select days. Follow along for the day-to-day, or join the list and we&rsquo;ll tell you first.</p>
          <div className="rev" style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
            <button className="btn btn-outline" onClick={() => go('home', { scrollToFlowers: true })}>Farm Gate &amp; Flowers</button>
            <button className="btn btn-outline" onClick={() => go('tubers')}>Dahlia Tubers</button>
          </div>
        </div>
        <div className="split-photo bg-photo rev" style={{ order: 2, backgroundImage: `url(${IMAGES.blushPatch})` }} />
      </div>

      <JoinBlock eyebrow="Visiting Soon?" headline="Join the community.<br>We'll tell you what's out." body="Farm gate days, pick-your-own dates and what's blooming that week — straight to your inbox before Instagram." />

      <InstagramSection />
    </div>
  );
}
